import React from 'react';
import { usePresenterDetails } from '../../../hooks/api/public/use-presenter-details';
import DetailsWrapper, { PageType } from '../../shared/DetailsWrapper';
import { getCurrentTimezone } from '../../../lib/helpers/dateHelper';

type Props = Record<string, unknown>

export const PresenterDetailsWrapper: React.FC<Props> = (props: Props): JSX.Element | null => {
  const { data } = usePresenterDetails();
  if (data) {
    const timeZone = data.eventTimeZone || getCurrentTimezone();

    return (
      <DetailsWrapper
        timeZone={timeZone}
        meetingDetails={data}
        type={PageType.PRESENTER}
        errorMessage={data.errorMessage}
      />
    );
  }
  return null;
};

export default PresenterDetailsWrapper;
